import React from 'react';
import { Wrapper, Container } from './style';
import { getNoToken,postNoToken } from '../../utils/request';
import { Toast } from 'antd-mobile';
import Config from '../../config';
import icon_login_clear from '../../assets/images/icon_login_clear.png';
import icon_username from '../../assets/images/icon_username.png';
import icon_password from '../../assets/images/icon_password.png';
import bg_03 from '../../assets/images/bg_03.png';
import { number } from 'echarts';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import bg_smll_01 from '../../assets/images/bg_smll_01.png';
import bg_smll_02 from '../../assets/images/bg_smll_02.png';
import icon_delete from '../../assets/images/icon_delete.png';
import icon_pgy from '../../assets/images/icon_pgy.png';
import img_code from '../../assets/images/img_code.png';
import img_code_02 from '../../assets/images/img_code_02.png';
import wx_share from '../../assets/images/wx_share.png';

class ZLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openId: '',
      username: '',
      password: '',
      codeText: '发送验证码',
      codeIsReseting: false,
      codeIsDowned: false,
      codeTimeDef: 60,
      codeTime: 60,

      isShowComponent: false,
      isShowComponent2: false,
      staticInfo: {}
    };
  }
  async componentDidMount() {
    document.title = '登录'
    let openId = this.props.match.params.id
    this.setState({openId})
    this.loadStaticInfo()
  }
  async loadStaticInfo(){
    let res = await getNoToken(`/pgy/user/${Config.appId}/appInitConfig`)
    this.setState({staticInfo: res.data.data})
  }
  inputChange(key, e){
    let value = e.target.value
    if(key == 'username'){
      if(value.length > 11){
        value = value.slice(0,11)
      }
    }
    if(key == 'password'){
      if(value.length > 6){
        value = value.slice(0,6)
      }
    }
    this.setState({[key]: value})
  }
  async sendCode(){
    let username = this.state.username
    if(username.substr(0, 1) != 1 || username.length != 11){
      Toast.info('手机号格式有误')
      return false
    }
    if(this.state.codeIsReseting){
      Toast.info(`${this.state.codeTime}秒后再发送`)
    } else {
      Toast.loading('正在发送', 10)
      let params = {mobile: username}
      let res = await postNoToken(`/pgy/user/${Config.appId}/sendCode`, params)
      Toast.hide()
      if(res.data.code == 100){
        if(res.data.biz_code == 20000){
          Toast.info('发送成功')
          this.setState({codeIsDowned: true})
          this.codeDown()
        } else if(res.data.biz_code == 1000){
          if(Config.appId == 'wx22a1f0da54a37d32'){
            console.log('王力的测试号')
            this.setState({isShowComponent: true})
          } else if(Config.appId == 'wx04bfeaa4425042ae'){
            console.log('水母来了')
            this.setState({isShowComponent: true})
          } else if(Config.appId == 'wxd97304f19a086804'){
            console.log('ivf')
            this.setState({isShowComponent2: true})
          }
        } else {
          Toast.info(res.data.msg)
        }
      } else {
        Toast.info(res.data.msg)
      }
    } 
  }
  codeDown(){
    let codeTime = this.state.codeTime
    if(codeTime == 0){
      this.setState({codeText: '获取验证码',codeTime: this.state.codeTimeDef,codeIsReseting: false}) 
    } else {
      this.setState({codeText: `重新获取(${codeTime}秒)`,codeTime: codeTime-1,codeIsReseting: true})
      setTimeout(() => {
        this.codeDown()
      }, 1000)
    } 
  }
  async login(){
    let openId = this.state.openId
    let username = this.state.username
    let password = this.state.password
    let codeIsDowned = this.state.codeIsDowned
    if(!username){
      Toast.info('请输入手机号')
      return false
    }
    if(!codeIsDowned){
      Toast.info('请发送验证码')
      return false
    }
    if(!password){
      Toast.info('请输入验证码')
      return false
    }
    let params = {mobile: username,code: password, openId}
    Toast.info('登录成功')
    Toast.loading('正在登录' ,60)
    let res = await postNoToken(`/pgy/user/${Config.appId}/login`, params)
    Toast.hide()
    if(res.data.code == 100){
      let token = res.data.data.token
      window.localStorage.setItem('token', token)
      this.props.history.push(`/list`)
    } else {
      Toast.info(res.data.msg)
    }
  }
  showComponent = e => {
    e.stopPropagation()
    this.setState({isShowComponent: true})
    this.setState({isShowComponent2: true})
  }
  hideComponent = e => {
    e.stopPropagation()
    this.setState({isShowComponent: false})
    this.setState({isShowComponent2: false})
  }
  clickComponentMain = e => {
    e.stopPropagation()
  }
  onCopy(){
    Toast.info('复制成功')
  }
  render() {
    let { username,password,codeIsReseting,codeText,isShowComponent,isShowComponent2,staticInfo } = this.state;
    return (
      <Wrapper>
        <Container>
          <div className="login">
            <img className="bg" src={bg_03} />
            <div className="list">
              <div className="item">
                <img className="label" src={icon_username} />
                <input type="number" placeholder="请输入手机号" value={username} onChange={e => this.inputChange('username', e)} />
              </div>
              <div className="item">
                <img className="label" src={icon_password} />
                <input type="number" placeholder="请输入验证码" value={password} onChange={e => this.inputChange('password', e)} />
                <div className={`code ${codeIsReseting?'err':''}`} onClick={() => this.sendCode()}>{codeText}</div>
              </div>
            </div>
            <div className="btns">
              <div className="btn" onClick={()=>this.login()}>登录</div>
            </div>
          </div>

          <div className={`component ${isShowComponent?'show':'hide'}`} onClick={this.hideComponent}>
            <div className="componentor" onClick={this.clickComponentMain}>
              <div className="bg_01">
                <span>THE DANDELION</span>
                <span>PROJECT</span>
              </div>
              <div className="bg_02">
                <div className="title">
                  <img src={icon_pgy} />
                  <span>提示</span>
                  <img src={icon_pgy} />
                </div>
                <p className="msg">很抱歉，您还没有加入蒲公英计划。如需加入，请添加工作人员微信好友了解详情。</p>
              </div>
              <div className="bg_03">
                {/* <div className="title">
                  <img src={icon_pgy} />
                  <span>我是新朋友</span>
                  <img src={icon_pgy} />
                </div> */}
                <p className="msg">您可以通过查找手机号码添加好友</p>
                <p className="phone"> 
                  <span>{staticInfo.csWx}</span>
                  <CopyToClipboard text={staticInfo.csWx} onCopy={this.onCopy}><b>复制</b></CopyToClipboard>
                </p>
                <p className="msg">也可以长按图片识别二维码添加好友</p>
                <img className="code" src={staticInfo.csQrcode} />
              </div>
            </div>
            <div className="close">
              <img src={icon_delete} />
            </div>
          </div>
          <div className={`component2 ${isShowComponent2?'show':'hide'}`} onClick={this.hideComponent}>
            <div className="componentor" onClick={this.clickComponentMain}>
              <div className="bg_01">
                <span>THE DANDELION</span>
                <span>PROJECT</span>
              </div>
              <div className="bg_02">
                <div className="title">
                  <img src={icon_pgy} />
                  <span>提示</span>
                  <img src={icon_pgy} />
                </div>
                <p className="msg">很抱歉，您还没有加入蒲公英计划。如需加入，请添加工作人员微信好友了解详情。</p>
              </div>
              <div className="bg_03">
                {/* <div className="title">
                  <img src={icon_pgy} />
                  <span>我是新朋友</span>
                  <img src={icon_pgy} />
                </div> */}
                <p className="msg">您可以通过查找手机号码添加好友</p>
                <p className="phone"> 
                  <span>{staticInfo.csWx}</span>
                  <CopyToClipboard text={staticInfo.csWx} onCopy={this.onCopy}><b>复制</b></CopyToClipboard>
                </p>
                <p className="msg">也可以长按图片识别二维码添加好友</p>
                <img className="code" src={staticInfo.csQrcode} />
              </div>
            </div>
            <div className="close">
              <img src={icon_delete} />
            </div>
          </div>
        </Container>
      </Wrapper>
    );
  }
}
export default ZLogin;